import { FC, useCallback } from "react";
import { Flex } from "@otrium/core";
import { HyperLink } from "src/atoms/HyperLink";
import { ChevronBottom, Select, Wrapper } from "./NativeSelect.styled";

interface Props {
  value: string;
  options: { [key: string]: string | number }[];
  handleSelect: (value: string) => void;
}

export const NativeSelect: FC<Props> = ({ value, options, handleSelect }) => {
  const option = options.find((e) => e.value === value);
  const onSelect = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      handleSelect(e.target.value);
    },
    [handleSelect]
  );
  return (
    <Wrapper>
      <Flex variant="centered">
        <HyperLink>{option?.text}</HyperLink>
        <ChevronBottom />
      </Flex>
      <Select onChange={onSelect} value={value}>
        {options.map((item) => (
          <option key={`option-${item.value}`} value={item.value}>
            {item.text}
          </option>
        ))}
      </Select>
    </Wrapper>
  );
};
